const BusinessTypes = {
  business: "Business Organization",
  wholesales: "Wholesales",
  restaurant: "Restaurant"
};

export default BusinessTypes;